import React from 'react';
import { faTimesCircle } from '@fortawesome/pro-regular-svg-icons';
import SIcon from './SIcon';

const Close = props => <SIcon {...props} icon={faTimesCircle} fa />;

export default Close;
